import './posts.scss'

function init() {

}

export default init
